var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getUiOptions } from './';
import _ from "lodash";

export function getFieldsetFields(props) {
    var idPrefix = props.idPrefix,
        idSchema = props.idSchema,
        uiSchema = props.uiSchema,
        uiOptions = props.uiOptions,
        registry = props.registry;
    var formContext = registry.formContext;


    var fieldset = [];

    if (uiOptions && uiOptions.fieldset) {

        uiOptions.fieldset.forEach(function (name) {

            var id = void 0;

            if (idPrefix && name) {
                id = idPrefix + '_' + name;
            } else {
                id = idSchema.$id;
            }

            var selected = false;

            if (formContext.expandId && formContext.expandId.startsWith(id)) {
                selected = true;
            }

            fieldset.push(_extends({}, props, {
                id: id,
                idPrefix: id,
                name: name,
                selected: selected,
                uiSchema: uiSchema[name] || {}
            }));
        });
    }

    var selected = _.find(fieldset, function (field) {
        return field.selected === true;
    });

    if (fieldset[0] && !selected) {
        fieldset[0].selected = true;
    }

    return fieldset;
}

export function getFieldsetFormData(props) {
    var formData = props.formData,
        schema = props.schema,
        uiOptions = props.uiOptions;


    if (schema.type && schema.type !== "object") {
        return formData;
    }

    var fieldsetFormData = {};

    if (uiOptions.fieldset) {

        uiOptions.fieldset.map(function (name) {
            if (formData && formData[name]) {
                fieldsetFormData[name] = formData[name];
            }
        });
    }

    return _extends({}, formData, fieldsetFormData);
}

export function getFieldset(props) {
    var _props = props,
        id = _props.id,
        uiSchema = _props.uiSchema,
        uiOptions = _props.uiOptions;


    var fieldset = uiOptions.fieldset || false;

    if (!fieldset) {
        return false;
    }

    props = _extends({}, props, {
        idPrefix: id
    });

    var fields = getFieldsetFields(props);
    var formData = getFieldsetFormData(props);

    return _extends({}, props, {
        fields: fields,
        formData: formData
    });
}